export default {
  printPackingSlip: {
    id: 'bo_sellers-orders-components-orders_table-actions-print_packing_slip',
    defaultMessage: 'Print packing slip',
  },
  printBackShipLabel: {
    id: 'bo_sellers-orders-components-orders_table-actions-print_back_ship_label',
    defaultMessage: 'Print BackShip label',
  },
  ship: {
    id: 'bo_sellers-orders-components-orders_table-actions-ship',
    defaultMessage: 'Ship',
  },
  sendCustomerReceipt: {
    id: 'bo_sellers-orders-components-orders_table-actions-send_customer_receipt',
    defaultMessage: 'Send receipt',
  },
} as const
